import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'namefilter'
})
@Injectable()
export class NameFilterPipe implements PipeTransform {
  transform(items: any[], field: string, value: string): any[] {
    if (!items) return [];
    return items.filter(it => it['name'] == value);
  }
}
